import { options_subCategory_loading } from './OptionsPaneLoading.locstring.json';
import loc from 'owa-localize';
import { Spinner, SpinnerType } from 'office-ui-fabric-react/lib/Spinner';

import * as React from 'react';

const styles = require('./OptionsPaneLoading.scss');

export default function OptionsPaneLoading() {
    return (
        <div className={styles.messageContainer}>
            <Spinner type={SpinnerType.large} />
            <div className={styles.messageText}>{loc(options_subCategory_loading)}</div>
        </div>
    );
}
